import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Svg"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 17.25H18C17.1716 17.25 16.5 16.5784 16.5 15.75V8.25C16.5 7.42157 17.1716 6.75 18 6.75H22.5V8.25H18V15.75H21V12.75H19.5V11.25H22.5V17.25ZM13.5 6.75L12 16.5L10.5 6.75H9L10.89 17.25H13.11L15 6.75H13.5ZM6 17.25H1.5V15.75H6V12.75H3C2.17157 12.75 1.5 12.0784 1.5 11.25V8.25C1.5 7.42157 2.17157 6.75 3 6.75H7.5V8.25H3V11.25H6C6.82843 11.25 7.5 11.9216 7.5 12.75V15.75C7.5 16.5784 6.82843 17.25 6 17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Svg.vue"]]);
